// Import necessary dependencies
import React, { useState, useEffect } from "react";
import { useTezos } from "../hooks/useTezos"; // Custom hook for Tezos interactions
import axios from "axios";

const CreateAuction = () => {
  const { getUserNFTs, createAuction } = useTezos();
  const [nfts, setNfts] = useState([]);
  const [selectedNFT, setSelectedNFT] = useState(null);
  const [startingBid, setStartingBid] = useState("");
  const [duration, setDuration] = useState("");
  const [userSales, setUserSales] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUserNFTs();
    fetchUserSales();
  }, []);

  const fetchUserNFTs = async () => {
    const userNFTs = await getUserNFTs();
    setNfts(userNFTs);
  };

  const fetchUserSales = async () => {
    try {
      const response = await axios.get("/api/user/sales");
      setUserSales(response.data.completedSales);
    } catch (error) {
      console.error("Error fetching user sales:", error);
    }
  };

  const handleCreateAuction = async () => {
    if (userSales < 10) {
      alert("You must complete at least 10 sales before creating an auction.");
      return;
    }

    if (!selectedNFT || !startingBid || !duration) {
      alert("Please fill all fields.");
      return;
    }

    setLoading(true);

    try {
      const auctionResponse = await createAuction(
        selectedNFT.id,
        startingBid,
        duration
      );
      if (auctionResponse.success) {
        await axios.post("/api/auctions/create", {
          nft_id: selectedNFT.id,
          start_bid: startingBid,
          duration,
          status: "active",
        });
        alert("Auction created successfully!");
      } else {
        alert("Failed to create auction on Blockchain.");
      }
    } catch (error) {
      console.error("Error creating auction:", error);
      alert("Error creating auction.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Create Auction</h2>
      <p>Your Completed Sales: {userSales}</p>
      <select
        onChange={(e) =>
          setSelectedNFT(nfts.find((nft) => nft.id === e.target.value))
        }
      >
        <option value="">Select NFT</option>
        {nfts.map((nft) => (
          <option key={nft.id} value={nft.id}>
            {nft.name}
          </option>
        ))}
      </select>
      <input
        type="number"
        placeholder="Starting Offer"
        value={startingBid}
        onChange={(e) => setStartingBid(e.target.value)}
      />
      <input
        type="number"
        placeholder="Duration (hours)"
        value={duration}
        onChange={(e) => setDuration(e.target.value)}
      />
      <button onClick={handleCreateAuction} disabled={loading}>
        {loading ? "Processing..." : "Create Auction"}
      </button>
    </div>
  );
};

export default CreateAuction;
